/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Board_Tracking_PlaceholderInputs */

const en_delivery_board_tracking_placeholder = /** @type {(inputs: Delivery_Board_Tracking_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste GoSend / Grab / rider tracking link...`)
};

const es_delivery_board_tracking_placeholder = /** @type {(inputs: Delivery_Board_Tracking_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega el enlace de seguimiento de UberEats / Glovo / repartidor...`)
};

const fr_delivery_board_tracking_placeholder = /** @type {(inputs: Delivery_Board_Tracking_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez le lien de suivi Deliveroo / UberEats / coursier...`)
};

const de_delivery_board_tracking_placeholder = /** @type {(inputs: Delivery_Board_Tracking_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracking-Link des Kuriers hier einfügen...`)
};

const id_delivery_board_tracking_placeholder = /** @type {(inputs: Delivery_Board_Tracking_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempel tautan pelacakan GoSend / Grab / kurir...`)
};

/** @type {(inputs: Delivery_Board_Tracking_PlaceholderInputs) => LocalizedString} */
const ja_delivery_board_tracking_placeholder = en_delivery_board_tracking_placeholder;

/** @type {(inputs: Delivery_Board_Tracking_PlaceholderInputs) => LocalizedString} */
const zh_delivery_board_tracking_placeholder = en_delivery_board_tracking_placeholder;

/** @type {(inputs: Delivery_Board_Tracking_PlaceholderInputs) => LocalizedString} */
const ar_delivery_board_tracking_placeholder = en_delivery_board_tracking_placeholder;

/** @type {(inputs: Delivery_Board_Tracking_PlaceholderInputs) => LocalizedString} */
const it_delivery_board_tracking_placeholder = en_delivery_board_tracking_placeholder;

/** @type {(inputs: Delivery_Board_Tracking_PlaceholderInputs) => LocalizedString} */
const ru_delivery_board_tracking_placeholder = en_delivery_board_tracking_placeholder;

/** @type {(inputs: Delivery_Board_Tracking_PlaceholderInputs) => LocalizedString} */
const pt_delivery_board_tracking_placeholder = en_delivery_board_tracking_placeholder;

/** @type {(inputs: Delivery_Board_Tracking_PlaceholderInputs) => LocalizedString} */
const ko_delivery_board_tracking_placeholder = en_delivery_board_tracking_placeholder;

/**
* | output |
* | --- |
* | "Paste GoSend / Grab / rider tracking link..." |
*
* @param {Delivery_Board_Tracking_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_board_tracking_placeholder = /** @type {((inputs?: Delivery_Board_Tracking_PlaceholderInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Board_Tracking_PlaceholderInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_board_tracking_placeholder(inputs)
	if (locale === "es") return es_delivery_board_tracking_placeholder(inputs)
	if (locale === "fr") return fr_delivery_board_tracking_placeholder(inputs)
	if (locale === "de") return de_delivery_board_tracking_placeholder(inputs)
	if (locale === "ja") return ja_delivery_board_tracking_placeholder(inputs)
	if (locale === "zh") return zh_delivery_board_tracking_placeholder(inputs)
	if (locale === "ar") return ar_delivery_board_tracking_placeholder(inputs)
	if (locale === "id") return id_delivery_board_tracking_placeholder(inputs)
	if (locale === "it") return it_delivery_board_tracking_placeholder(inputs)
	if (locale === "ru") return ru_delivery_board_tracking_placeholder(inputs)
	if (locale === "pt") return pt_delivery_board_tracking_placeholder(inputs)
	return ko_delivery_board_tracking_placeholder(inputs)
});